import { useRef } from 'react';

import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';

import styles from './Backdrop.module.css';

const backdropClassNames = {
   enter: styles['backdrop-enter'],
   enterActive: styles['backdrop-enter-active'],
   exit: styles['backdrop-exit'],
   exitActive: styles['backdrop-exit-active']
};

interface Props {
   type: 'flyout' | 'dialog';
   isOpen: boolean;
   closeOnOutsideClick?: boolean;
   onClose?: () => void;
}

export const Backdrop = ({ type, isOpen, closeOnOutsideClick, onClose }: Props) => {
   const nodeRef = useRef(null);

   const handleBackdropClicked = () => {
      if (!closeOnOutsideClick) return;
      onClose?.();
   };

   return (
      <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={200} classNames={backdropClassNames} mountOnEnter unmountOnExit>
         <div
            ref={nodeRef}
            aria-hidden="true"
            data-testid="backdrop"
            className={classNames('fixed inset-0 z-[80]', type === 'flyout' && 'bg-component-surfaces-flyout-background-color-scrimmed', type === 'dialog' && 'bg-component-feedback-dialog-backdrop-color-background')}
            onClick={handleBackdropClicked}
         />
      </CSSTransition>
   );
};
